import {Component, EventEmitter, forwardRef, Inject, Input, OnChanges, OnInit, Output} from '@angular/core';
import {CreelPositionDetailsComponent} from '@presentation/pages/textile-data/material-set/add/creel-position-details/creel-position-details.component';
import {convertRGBToHexadecimalColorCode} from '@vdw/angular-component-library';
import {isEmpty, isEqual, size} from 'lodash-es';

@Component({
  selector: 'app-material-type',
  templateUrl: './material-type.component.html',
  styleUrls: ['./material-type.component.scss']
})
export class MaterialTypeComponent implements OnInit, OnChanges {
  @Input() public horizontalPositionOfMaterialTypeCreelPosition: any;
  @Input() public indexOfHorizontalPositionOfCreelPosition: number;
  @Input() public canEditMaterialSet: boolean;
  @Output() public typeChanges: EventEmitter<void> = new EventEmitter<void>();

  public materialTypeName: string;

  private readonly maxMaterialTypeNameSize = 10;

  public constructor(@Inject(forwardRef(() => CreelPositionDetailsComponent)) private creelPositionDetailsComponent: CreelPositionDetailsComponent) {}

  public ngOnInit(): void {
    this.typeChanges.emit();
    this.setMaterialTypeName();
  }

  public ngOnChanges(): void {
    this.typeChanges.emit();
  }

  public getPreviewColorCode(): string {
    return convertRGBToHexadecimalColorCode(this.horizontalPositionOfMaterialTypeCreelPosition.color.rgb);
  }

  public getMaterialTypePositionViewIndex(): number {
    return this.indexOfHorizontalPositionOfCreelPosition + 1;
  }

  public incrementAmount(event: MouseEvent): void {
    event.stopPropagation();
    this.horizontalPositionOfMaterialTypeCreelPosition.amount += 1;

    this.creelPositionDetailsComponent.emitCreelPositionChanges();
  }

  public decrementAmount(event: MouseEvent): void {
    event.stopPropagation();

    const amount = this.horizontalPositionOfMaterialTypeCreelPosition.amount;
    this.horizontalPositionOfMaterialTypeCreelPosition.amount = !isEqual(amount, 1) ? amount - 1 : 1;

    this.creelPositionDetailsComponent.emitCreelPositionChanges();
  }

  public canDecrementAmount(): boolean {
    return !isEqual(this.horizontalPositionOfMaterialTypeCreelPosition.amount, 1) && this.canEditMaterialSet;
  }

  public onMaterialTypeClick(isSelected: boolean, event: MouseEvent): void {
    if (this.canEditMaterialSet) {
      event.stopPropagation();

      const {metaKey, altKey} = event;

      if (metaKey || altKey) {
        this.horizontalPositionOfMaterialTypeCreelPosition.isSelected = !isSelected;
      } else {
        const selectedMaterialTypes = this.creelPositionDetailsComponent.getAllSelectedMaterialSetTypesAndGroups(this.creelPositionDetailsComponent.creelPosition.horizontalPositionsOfCreelPosition);
        this.creelPositionDetailsComponent.deselectAllSelectedMaterialTypesAndGroups();

        this.horizontalPositionOfMaterialTypeCreelPosition.isSelected = isEmpty(selectedMaterialTypes) || isEqual(size(selectedMaterialTypes), 1) ? !isSelected : true;
      }
    }
  }

  public canShowSelectedIndicator(): boolean {
    return this.horizontalPositionOfMaterialTypeCreelPosition.isSelected;
  }

  private setMaterialTypeName(): void {
    if (this.horizontalPositionOfMaterialTypeCreelPosition.isColor()) {
      this.materialTypeName = this.horizontalPositionOfMaterialTypeCreelPosition.color.name;
    } else if (this.horizontalPositionOfMaterialTypeCreelPosition.isYarnType()) {
      this.materialTypeName = this.horizontalPositionOfMaterialTypeCreelPosition.yarnType.name;
    }
  }
}
